import app from 'flarum/common/app';
import Tooltip from 'flarum/common/components/Tooltip';
import Icon from 'flarum/common/components/Icon';
import Widget from 'ext:fof/forum-widgets-core/common/components/Widget';
import extractText from 'flarum/common/utils/extractText';
export default class ForumStatsWidgetWidget extends Widget {
  className() {
    return 'FoF-ForumStatsWidget';
  }
  icon() {
    return 'fas fa-chart-pie';
  }
  title() {
    return extractText(app.translator.trans('fof-forum-stats-widget.forum.widget.title'));
  }
  content() {
    const stats = app.forum.attribute('fof-forum-stats-widget.stats');
    return m("div", {
      className: "FoF-ForumStatsWidget-grid"
    }, Object.keys(stats).map(stat => m(Tooltip, {
      text: stats[stat].label
    }, m("span", {
      className: "FoF-ForumStatsWidget-grid-item"
    }, m("span", {
      className: "FoF-ForumStatsWidget-grid-item-icon"
    }, m(Icon, {
      name: stats[stat].icon
    })), m("span", {
      className: "FoF-ForumStatsWidget-grid-item-value"
    }, stats[stat].prettyValue)))));
  }
}
flarum.reg.add('fof-forum-stats-widget', 'common/components/ForumStatsWidget', ForumStatsWidgetWidget);